import React, { FC } from 'react';
import { Button, ButtonProps } from '@mui/material';
import './SecondaryButton.css';

interface ReusableButtonProps extends ButtonProps {
    onClick?: () => void;
    children: React.ReactNode;
    className?: string;
    icon?: React.ReactNode; // Add icon prop
}

const ReusableButton: FC<ReusableButtonProps> = ({ onClick, children, className, icon, ...props }) => {
    return (
        <Button 
            className={className ? className : 'secondaryButton'}
            onClick={onClick} 
            {...props}
        >
            {icon && <span className="buttonIcon">{icon}</span>}
            {children}
        </Button>
    );
};

export default ReusableButton;
